import React, { Component } from 'react'
import PropTypes from 'prop-types'
import translate from 'react-i18next/dist/commonjs/translate'
import CloseFilterSVG from 'component/svgComponents/close'

const MODAL_SIZES = ['sm', 'md', 'lg']

class Modal extends Component {
  static propTypes = {
    buttonClass: PropTypes.string,

    /* Title of the modal */
    title: PropTypes.string,

    /* Determines the modal size */
    size: PropTypes.oneOf(MODAL_SIZES),

    /* Callback that will be triggered when the modal closes  */
    onCloseModal: PropTypes.func,

    /* Callback that will be triggered when the modal open  */
    onOpenModal: PropTypes.func,

    /* Callback that will be triggered when the modal is confirmed */
    onConfirm: PropTypes.func,

    /* Props children */
    children: PropTypes.object,

    /* Allow to render a child with close/confirm props */
    renderChildrenWithProps: PropTypes.func,

    /* Modal open button text */
    buttonText: PropTypes.string,

    /* Modal confirm button text */
    confirmButtonText: PropTypes.string,

    /* Confirmation types (danger or success) */
    confirmType: PropTypes.string,

    /* Modal confirm button disabled */
    isConfirmButtonDisabled: PropTypes.bool,

    /* Function for rendering a custom button */
    renderButton: PropTypes.func,

    /* String for btn cancel text */
    cancelButtonText: PropTypes.string,

    /* Bool that tells the modal if the header should be shown (default true) */
    showHeader: PropTypes.bool,

    /* Bool that tells the modal if the footer should be shown (default true) */
    showFooter: PropTypes.bool,

    /* Bool that tells the modal if it should be fixed open (default false) */
    isOpen: PropTypes.bool,

    /* Bool that tells the modal if it should disable the max-height (usefull for modals with selects) */
    disableMaxHeight: PropTypes.bool,

    /* Translation method */
    translate: PropTypes.func,

    /* If "visible" than the modal will not scroll the content */
    overflow: PropTypes.string,

    /* Bool that tells the modal if the content should be centered (default true) */
    center: PropTypes.bool,

    /* Disable bg click close */
    disabledBgClickClosing: PropTypes.bool,

    /* Custom classname to modal */
    className: PropTypes.string,
  }

  static defaultProps = {
    size: 'md',
    confirmButtonText: 'Confirmar',
    isConfirmButtonDisabled: false,
    showHeader: true,
    showFooter: true,
    disableMaxHeight: false,
    className: '',
  }

  state = {
    /* Stores the information of wheter the modal is or not shown */
    isOpen: false,
  }

  componentDidMount() {
    const { isOpen } = this.props
    if (isOpen) {
      this.setState({ isOpen })
    }
  }

  onConfirm = () => {
    const { onConfirm = () => {} } = this.props
    this.setState({ isOpen: false }, onConfirm)
  }

  onClose = () => {
    const { onCloseModal = () => {} } = this.props
    this.setState({ isOpen: false }, onCloseModal)
  }

  openModal = () => {
    const { onOpenModal = () => {} } = this.props
    this.setState({ isOpen: true }, onOpenModal)
    window.scrollTo(0, 0)
  }

  renderDefaultButton = () => {
    const { buttonText, onClick } = this.getButtonProps()
    return (
      <button className='open-modal-button' onClick={onClick}>
        {buttonText}
      </button>
    )
  }

  getButtonProps = () => {
    const { buttonText } = this.props
    return { onClick: this.openModal, buttonText }
  }

  render() {
    const {
      buttonClass,
      center,
      overflow,
      title,
      size,
      renderButton,
      children,
      renderChildrenWithProps,
      showHeader,
      showFooter,
      disableMaxHeight,
      translate,
      className,
      buttonText,
      disabledBgClickClosing,
    } = this.props

    const { isOpen } = this.state
    return (
      <>
        {(!renderButton && !buttonText) ||
          (renderButton
            ? renderButton(this.getButtonProps())
            : this.renderDefaultButton(this.getButtonProps()))}
        {isOpen && (
          <>
            <div
              className={`bg ${disableMaxHeight ? 'no-max-height' : ''}`}
              onClick={() => !disabledBgClickClosing && this.onClose()}
            >
              <div
                className={`custom-modal ${size} ${center && 'center'} ${
                  className || ''
                }`}
                onClick={(e) => {
                  e.preventDefault()
                  e.stopPropagation()
                }}
              >
                {showHeader && (
                  <div className='custom-modal-title'>
                    <h3>{title}</h3>
                    <i className='glyph glyph-times' />
                    <span
                      className='custom-modal-close-icon'
                      onClick={this.onClose}
                    >
                      <CloseFilterSVG />
                    </span>
                  </div>
                )}
                <div
                  className={`custom-modal-content ${
                    overflow === 'visible'
                      ? 'overflow-visible'
                      : 'overflow-auto'
                  }`}
                >
                  {renderChildrenWithProps
                    ? renderChildrenWithProps({
                        onClose: this.onClose,
                        onConfirm: this.onConfirm,
                      })
                    : children}
                </div>
                {showFooter && (
                  <div className='custom-modal-footer'>
                    <button
                      className={`custom-modal-close-button ${buttonClass}`}
                      onClick={this.onClose}
                    >
                      {translate('close_button_label')}
                    </button>
                  </div>
                )}
              </div>
            </div>
          </>
        )}
      </>
    )
  }
}

export default translate(null, { wait: true, translateFuncName: 'translate' })(
  Modal
)
